module.exports = __webpack_public_path__ + "img/icon_upload_del.dd5fc6d3.svg";